import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";

const SelectStatus = ({ value, onChange }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const options = [
    {
      id: "approve",
      name: "Approve",
    },
    {
      id: "done",
      name: "Done",
    },
    {
      id: "reject",
      name: "Reject",
    },
    {
      id: "pending",
      name: "Pending",
    },
    {
      id: "draft",
      name: "Draft",
    },
  ];

  const getStatus = async () => {
    setLoading(true);
    const newData = options;
    const filteredData = newData.filter(
      (item) => !listData.find((existingItem) => existingItem.id === item.id)
    );
    setData((prevData) => [...prevData, ...filteredData]);
    setLoading(false);
  };

  useEffect(() => {
    getStatus();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Pilih Status"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
      }))}
    />
  );
};

export default SelectStatus;
